import React from "react";
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  EditButton,
  SimpleForm,
  TextInput,
  SelectField,
  SelectInput,
  NumberInput,
  Filter,
  DateField,
} from "react-admin";

import {
  required,
  maxLength,
  minLength,
  email,
  zipcode,
  number,
} from "./../../utils/validations";

const LinkField = ({ record, history }) => {
  const clicked = () => {
    sessionStorage.setItem("merchantId", record.id);
    sessionStorage.setItem("merchantUrl", `merchants/${record.id}`);
    sessionStorage.setItem("merchantName", record.name);

    history.push("/mrcht/categories");
  };
  return (
    <span
      onClick={clicked}
      style={{ fontSize: "14px", color: "blue", cursor: "pointer" }}
    >
      {record.name}
    </span>
  );
};

const timeChoices = [
  { id: 0, name: "12:00 AM" },
  { id: 100, name: "01:00 AM" },
  { id: 200, name: "02:00 AM" },
  { id: 300, name: "03:00 AM" },
  { id: 400, name: "04:00 AM" },
  { id: 500, name: "05:00 AM" },
  { id: 600, name: "06:00 AM" },
  { id: 700, name: "07:00 AM" },
  { id: 800, name: "08:00 AM" },
  { id: 830, name: "08:30 AM" },
  { id: 900, name: "09:00 AM" },
  { id: 930, name: "09:30 AM" },
  { id: 1000, name: "10:00 AM" },
  { id: 1030, name: "10:30 AM" },
  { id: 1100, name: "11:00 AM" },
  { id: 1130, name: "11:30 AM" },
  { id: 1200, name: "12:00 PM" },
  { id: 1230, name: "12:30 PM" },
  { id: 1300, name: "01:00 PM" },
  { id: 1330, name: "01:30 PM" },
  { id: 1400, name: "02:00 PM" },
  { id: 1430, name: "02:30 PM" },
  { id: 1500, name: "03:00 PM" },
  { id: 1530, name: "03:30 PM" },
  { id: 1600, name: "04:00 PM" },
  { id: 1630, name: "04:30 PM" },
  { id: 1700, name: "05:00 PM" },
  { id: 1730, name: "05:30 PM" },
  { id: 1800, name: "06:00 PM" },
  { id: 1830, name: "06:30 PM" },
  { id: 1900, name: "07:00 PM" },
  { id: 1930, name: "07:30 PM" },
  { id: 2000, name: "08:00 PM" },
  { id: 2030, name: "08:30 PM" },
  { id: 2100, name: "09:00 PM" },
  { id: 2130, name: "09:30 PM" },
  { id: 2200, name: "10:00 PM" },
  { id: 2230, name: "10:30 PM" },
  { id: 2300, name: "11:00 PM" },
  { id: 2330, name: "11:30 PM" },
];

const choices = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];

const statusChoices = [
  { id: "O", name: "Open" },
  { id: "C", name: "Close" },
];

const foodCategoryChoices = [
  { id: 0, name: "Veg" },
  { id: 1, name: "Nonveg" },
  { id: 2, name: "Veg & Nonveg" },
];

const deliveryTimeChoices = [
  { id: 30, name: "30 Mins" },
  { id: 45, name: "45 Mins" },
  { id: 60, name: "60 Mins" },
  { id: 90, name: "90 Mins" },
  { id: 120, name: "120 Mins" },
];

// const starRatingChoices = [
//     { id: 0, name: 'No Rating' },
//     { id: 3, name: '3 Star' },
//     { id: 3.5, name: '3.5 Star' },
//     { id: 4, name: '4 Star' },
//     { id: 4.5, name: '4.5 Star' },
//     { id: 5, name: '5 Star' }
// ];

const MerchantFilter = (props) => (
  <Filter {...props}>
    <TextInput source="name" label="Name" />
    <TextInput source="contactNo1" label="Mobile No" />
  </Filter>
);

export const MerchantList = (props) => (
  <List
    {...props}
    title="Restaurants"
    bulkActionButtons={false}
    filters={<MerchantFilter />}
    sort={{ field: "creationTime", order: "DESC" }}
  >
    <Datagrid>
      <LinkField source="name" label="Name" {...props} />
      <TextField source="contactNo1" label="Mobile No" />
      <TextField source="address.address" label="Address" />
      <TextField source="minOrderAmount" label="Minimum Order Amount" />
      <TextField source="deliveryCharges" label="Delivery Charges" />
      <SelectField
        source="openingTime"
        label="Opening Time"
        choices={timeChoices}
      />
      <SelectField
        source="closingTime"
        label="Closing Time"
        choices={timeChoices}
      />
      <SelectField source="enabled" label="Enabled" choices={choices} />
      <DateField source="creationTime" label="Creation Time" showTime />
      <EditButton />
    </Datagrid>
  </List>
);

const MerchantTitle = ({ record }) => {
  return <span>Restaurant {record ? `"${record.name}"` : ""}</span>;
};

const validateName = [required(), minLength(2), maxLength(40)];
const validatePhone = [
  required(),
  number("Only numbers allowed"),
  minLength(10),
  maxLength(15),
];

export const MerchantEdit = (props) => (
  <Edit title={<MerchantTitle />} {...props} redirect="list" actions={null}>
    {createUpdateForm}
  </Edit>
);

const createUpdateForm = (
  <SimpleForm redirect="list">
    <TextInput label="Name" source="name" validate={validateName} />
    <TextInput label="Address" source="address.address" validate={required()} />
    <TextInput label="City" source="address.city" />
    <TextInput label="State" source="address.state" />
    <TextInput label="Zipcode" source="address.pincode" validate={zipcode()} />
    <TextInput
      label="Mobile Number"
      source="contactNo1"
      validate={validatePhone}
    />
    <TextInput label="Email-Address" source="emailId" validate={email()} />
    <TextInput label="Image URL" source="imageUrl" fullWidth />
    <TextInput label="Speciality" source="description" validate={required()} />
    <SelectInput
      label="Opening Time"
      source="openingTime"
      validate={required()}
      choices={timeChoices}
    />
    <SelectInput
      label="Closing Time"
      source="closingTime"
      validate={required()}
      choices={timeChoices}
    />
    <SelectInput
      label="Delivery Time"
      source="deliveryTime"
      validate={required()}
      choices={deliveryTimeChoices}
    />
    <SelectInput
      label="Category"
      source="subType"
      validate={required()}
      choices={foodCategoryChoices}
    />
    {/* <SelectInput
        label="Rating"
        source="rating"
        validate={required()}
        defaultValue={0}
        choices={starRatingChoices} /> */}
    <NumberInput
      label="Limit for free delivery"
      source="freeDelivery"
      defaultValue={1000}
      validate={required()}
    />
    <NumberInput
      label="Delivery Charges"
      source="deliveryCharges"
      defaultValue={30}
      validate={required()}
    />
    <NumberInput
      label="Amount For Two"
      source="amountForTwo"
      defaultValue={250}
      validate={required()}
    />
    <NumberInput
      label="Minimum Order Amount"
      source="minOrderAmount"
      defaultValue={100}
      validate={required()}
    />
    <NumberInput
      label="GST %"
      source="taxPercentage"
      validate={required()}
      defaultValue={0}
    />
    <SelectInput
      label="Enabled"
      source="enabled"
      validate={required()}
      choices={choices}
    />
    <SelectInput
      label="Status"
      source="status"
      validate={required()}
      choices={statusChoices}
    />
    <NumberInput
      label="Sort Key"
      source="sortKey"
      defaultValue={0}
      validate={required()}
    />
    <NumberInput
      label="Business %"
      source="businessPercentage"
      validate={required()}
      defaultValue={0}
    />

    <NumberInput
      label="Latitude"
      source="latitude"
      validate={required()}
      defaultValue={0}
    />

    <NumberInput
      label="Longitude"
      source="longitude"
      validate={required()}
      defaultValue={0}
    />

    <TextInput label="Offer Short Text" source="offerShortText" />

    <TextInput label="Offer Description (If Any)" source="offerDescription" />
  </SimpleForm>
);

export const MerchantCreate = (props) => (
  <Create {...props} redirect="list" title="Create Restaurant">
    {createUpdateForm}
  </Create>
);
